const AcademicSchedule = () => {
    return (
        <div id="timing" className="vision-card">
                <h3>ACADEMIC SHEDULE</h3>

                <p>Summer Timing: 7:30 AM to 1:30 PM</p>
                <p>Winter Timing: 8:30 AM to 2:30 PM</p>
                <p>Office Timing: 9:00 AM to 4:00 PM</p>
            </div>
    );
};

export default AcademicSchedule;